import { Chart, LineController, LinearScale, TimeScale, PointElement, LineElement, Tooltip, Decimation } from 'chart.js';
import 'chartjs-adapter-luxon';

Chart.register(
    LineController,
    LinearScale,
    TimeScale,
    PointElement,
    LineElement,
    Tooltip,
);

const locales = {
    'ru': {
        code: 'ru-RU',
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    },
    'kk': {
        code: 'kk-KZ',
        months: ['Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан'],
        monthsShort: ['Қаң', 'Ақп', 'Нау', 'Сәу', 'Мам', 'Мау', 'Шіл', 'Там', 'Қыр', 'Қаз', 'Қар', 'Жел'],
    },
    'en': {
        code: 'en-US',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    }
};


export default function (element, data) {
    const valuePrefix = data.valuePrefix;
    const valuePostfix = data.valuePostfix;
    const valueTooltipPrefix = data.valueTooltipPrefix;
    const valueTooltipPostfix = data.valueTooltipPostfix;   
    
    const plotDataJson = JSON.parse(data.plot
        .replace(/O/g, '{')
        .replace(/C/g, '},')
        .replace(/x/g, '"x":')
        .replace(/y/g, ',"y":'));
    
    let plotData = plotDataJson.map((item) => {
        // item.x = new Date(item.x * 3600000);
        item.x = new Date(item.x * 1000);
        return item;
    });

    let preparedData = prepareData();

    let pageLang = window.Application.config.lang_code;
    let minDate = plotData[0].x;
    let maxDate = plotData[plotData.length - 1].x;

    let beginPeriod = minDate;

    if (window.innerWidth > 1240) {
        var aspectRatio = 4.5;
        var chartHeight = '286px';
    } else {
        var aspectRatio = 2.5;
        var chartHeight = '365px';
    }

    const chart = new Chart(element.querySelector(".chart-canvas"), {
        type: 'line',
        data: {
            datasets: [{
                spanGaps: true,
                label: '',
                data: preparedData,
                fill: false,
                borderColor: '#007660',
                pointStyle: false,
                borderWidth: 1,
            }]
        },
        options: {
            aspectRatio: aspectRatio,
            height: chartHeight,
            interaction: {
                mode: 'nearest',
                axis: 'x',
                intersect: false
            },
            scales: {
                x: {
                    grid: {
                        display: true,
                        drawOnChartArea: false,
                    },
                    type: 'time',
                    // min: minDate,
                    // max: maxDate,
                    // offsetAfterAutoskip: true,
                    // time: {
                    //     unit: 'day',
                    //     minUnit: 'day',
                    // },
                    ticks: {
                        source: 'data',
                        font: {
                            size: 12,
                            family: 'Montserrat',
                        },
                        color: '#494746',
                        callback: function(value, index, values) {
                            const date = new Date(value);
                            return formatButtonDate(date, pageLang, 'x-short');
                        },
                        // maxRotation: 0, 
                        // autoSkip: false,
                    },
                },
                y: {
                    border: {
                        display: false,
                    },
                    afterFit(scale) {
                        scale.width = window.innerWidth < 560 ? 60 : 80; 
                    },
                    ticks: {
                        padding: 6,
                        font: {
                            size: 12,
                            family: 'Montserrat',
                        },
                        callback: function(value, index, values) {
                            let formattedNumber = new Intl.NumberFormat('ru-RU', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                useGrouping: true
                            }).format(value);
                            return valuePrefix + formattedNumber + valuePostfix;
                        }
                    },
                    grid: {
                        font: {
                            size: 12,
                        },
                        color: '#b3b7c0',
                        lineWidth: function(context) {
                            return context.tick.value === 0 ? 2 : 1;
                        }
                    }
                }
            },
            plugins: {
                tooltip: {
                    bodyFont: {
                        family: 'Montserrat',
                    },
                    titleFont: {
                        family: 'Montserrat',
                    },
                    footerFont: {
                        family: 'Montserrat',
                    },
                    callbacks: {
                        title: function (context) {
                            const date = new Date(context[0].raw.x);
                            return formatButtonDate(date, pageLang, 'full');
                        },
                        label: function () {
                            return null;
                        },
                        footer: function (context) {
                            let number = context[0].parsed.y.toFixed(4);
                            let formattedNumber = new Intl.NumberFormat('ru-RU', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                                useGrouping: true
                            }).format(number);

                            return valueTooltipPrefix + ' ' + formattedNumber + valueTooltipPostfix;
                        }
                    }
                },
                datalabels: {
                    display: false
                }
            }
        }
    });

    function formatButtonDate(date, pageLang = 'ru', $format = 'full') {
        let monthIndex = date.getUTCMonth();
        let monthNumber = monthIndex + 1;
        let monthOut = monthNumber < 10 ? '0' + (monthNumber) : monthNumber;
        
        const month = locales[pageLang].monthsShort[monthIndex];
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();

        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');

        if ($format == 'full') {
            // return `${month} ${day}, ${year}`;
            return `${day}.${monthOut}.${year}`;
        } else if ($format == 'x-short') {
            return `${day}.${monthOut}`
        } else {
            return [`${month}`, `${day}`];
        }
    }

    element.querySelectorAll(".period-btn").forEach(function (btn) {
        btn.addEventListener("click", function (event) {
            const period = btn.dataset.period;

            element.querySelector(".period-btn.current")?.classList.remove("current");
            btn.classList.add("current");

            let step = 'month';
            let thinStepDays = null;
            let unit = 'week';

            if (period == "1month") {
                beginPeriod = new Date(maxDate - 31 * 24 * 60 * 60 * 1000);
                step = 'day';
                unit = 'day';
            } else if (period == "6month") {
                beginPeriod = new Date(maxDate - 180 * 24 * 60 * 60 * 1000);
                step = 'week';
            } else if (period == "1year") {
                beginPeriod = new Date(maxDate - 365 * 24 * 60 * 60 * 1000);
                step = 'month';
                thinStepDays = 4;
            } else {
                beginPeriod = minDate;
                thinStepDays = 4;

            }

            // chart.options.scales.x.time.unit = unit;
            // chart.options.scales.x.time.minUnit = step;

            const filteredData = plotData.filter(item => item.x >= beginPeriod);

            if (filteredData.length) {
                // let firstValue = filteredData[0].y;
                let normalized = filteredData.map(item => ({
                    x: item.x,
                    y: item.y,
                    // y: ((item.y - firstValue) / firstValue) * 100,
                }));

                if (thinStepDays) {
                    normalized = thinData(normalized, thinStepDays);
                }

                chart.data.datasets[0].data = normalized;
                chart.options.scales.x.min = beginPeriod;
                chart.update();
            }
        });
    });
   
    // подготовка данных
    function prepareData() {        
        if (!plotData.length) return [];

        let minDate = plotData[0].x;
        let maxDate = plotData[plotData.length - 1].x;
        let differenceInDays = (maxDate - minDate) / (24 * 60 * 60 * 1000);
        
        // let firstValue = plotData[0].y;
        let normalized = plotData.map(item => ({
            x: item.x,
            // y: ((item.y - firstValue) / firstValue) * 100,
            y: item.y,
        }));

        // если данных много проредить массив
        let step = differenceInDays > 1000 ? 4 : differenceInDays > 365 ? 4 : 1;

        return differenceInDays > 365
            ? thinData(normalized, step)
            : normalized;
    }

    // Прореживание массива
    function thinData(data, stepDays = 7) {
        const result = [];
        let lastDate = null;
        const stepMs = stepDays * 24 * 60 * 60 * 1000;

        for (const item of data) {
            if (!lastDate || item.x - lastDate >= stepMs) {
                result.push(item);
                lastDate = item.x;
            }
        }

        const lastItem = data[data.length - 1];
        const lastResult = result[result.length - 1];

        if (!lastResult || lastResult.x !== lastItem.x) {
            result.push(lastItem);
        }

        return result;
    }
}